import { render, staticRenderFns } from "./BullInfo.vue?vue&type=template&id=46d119d0&"
import script from "./BullInfo.vue?vue&type=script&lang=js&"
export * from "./BullInfo.vue?vue&type=script&lang=js&"
import style0 from "./BullInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports